module.exports = __webpack_public_path__ + "resources/icon-gift-mask.3bff86196cea5b58.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/img/icon-gift-mask.png
// module id = 800
// module chunks = 0 1